module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.open
    }
  }, [_c('a', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "auto",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "icon-shield icon text-primary-dk"
  }), _vm._v(" "), _c('span', [_vm._v("Espirito Santo")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-sub dk"
  }, [_vm._m(1), _vm._v(" "), _c('li', [(!_vm.ACL.check('coordES', _vm.currentUser.id)) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'solicitacoes-remocao',
        query: {
          tipoGrv: _vm.GRV_ESPIRITO_SANTO
        }
      }
    }
  }, [_c('span', [_vm._v("Solicitações de Remoção")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(!_vm.ACL.check('coordES', _vm.currentUser.id)) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'grv',
        query: {
          tipoGrv: _vm.GRV_ESPIRITO_SANTO
        }
      }
    }
  }, [_c('span', [_vm._v("GRVs")])]) : _vm._e()], 1), _vm._v(" "), _c('Policiais')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right text-muted"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-right text"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-fw fa-angle-down text-active"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-sub-header"
  }, [_c('a', [_c('span', {
    staticClass: "text-muted teste"
  }, [_vm._v("Espirito Santo")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f378e2d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/menu/EspiritoSanto.vue
// module id = 2091
// module chunks = 18